{
  "cash": "Cash",
  "cash-management-account": "Cash Management Account",
  "cash-management-accounts": "Cash Management Accounts",
  "certificate-of-deposit": "Certificate of Deposit",
  "certificates-of-deposit": "Certificates of Deposit",
  "checking-account": "Checking Account",
  "checking-accounts": "Checking Accounts",
  "money-market-account": "Money Market Account",
  "money-market-accounts": "Money Market Accounts",
  "savings-account": "Savings Account",
  "savings-accounts": "Savings Accounts",
  "treasury-bill": "Treasury Bill",
  "treasury-bills": "Treasury Bills",

  "cash-savings-contributions-sum-table-title": "Cash Savings",
  "cash-savings-contributions-sum-table-sum-title": "Total Annual Savings"
}
